import Cookies from "js-cookie";
import { beforeSSO, afterSSO } from "@/api/user";
import { errorInfo, alertBox } from "@/utils/common";
import i18n from "@/i18n/i18n";
import { setToken } from '@/utils/auth';
import { pick } from "lodash";

// 跳转SSO登录页面
export const toSSOLogin = (options ={}) => {
  const {type, redirect_url} = options;
  // 删除cookie信息..., JSESSIONID_StageNow存储用户信息字段
  Cookies.remove("JSESSIONID_StageNow");
  return beforeSSO()
    .then((res) => {
      if (res.success) {
        // 后端返回IOT平台后端接口和apiKey
        const { url, apiKey } = res.data;
        // 记录当前页面地址作为登录成功之后的系统跳转地址
        let redirectUrl = redirect_url? window.location.origin + redirect_url.replace(/\/\//g, '/') : window.location.href.split("?")[0];
        // 转换后端返回的接口地址为SSO登录地址
        let ossUrl = url.replace("/api", "/portal/login");
        // 存储IOT平台地址
        localStorage.setItem("__IOT_URL__", url.replace("/api", "/"));
        // 跳转SSO登录页面，并携带上必要参数
        // 跳转到IOT登录页面登录之后，后端会自动重定向到回调地址并带上encryptInfo
        window.location.href = `${ossUrl}?apiKey=${apiKey}&redirectUrl=${redirectUrl}` + (type? `&type=${type}` : '');
      } else {
        errorInfo("获取apiKey失败，请联系管理员");
      }
    })
    .catch((e) => {
      errorInfo("获取apiKey失败，请联系管理员");
    });
};

/**
 * 获取用户信息
 * @param {*} encryptInfo
 * @returns
 */
export const getUserInfo = (encryptInfo) => {
  return afterSSO({ encryptInfo: decodeURIComponent(encryptInfo) }).then((response) => {
    if (response && response.success) {
      // 存储token 携带到请求头
      setToken(response.data.token);
      // localStoage存储用户信息，在需要的时候获取使用（可选）
      localStorage.setItem("__USER_INFO__", JSON.stringify(response.data.user));
      // cookie存储用户信息，在需要的时候获取使用（可选）用于判断当前登录状态
      Cookies.set("JSESSIONID_StageNow", JSON.stringify(pick(response.data.user, ['id'])), {
        expires: 1,
      });
    }
    return response.success;
  });
};

/**
 * 没有子系统权限
 * @param {*} code
 * @param {*} url
 * @returns
 */
export const handleNoAuth = ({errorCode, url}) => {
   // 根据错误码判断
   alertBox(i18n.t(`code.${errorCode}`), () => {
    if (url || localStorage.getItem("__IOT_URL__")) {
      window.location.href = url || localStorage.getItem("__IOT_URL__"); // 跳转到IOT首页
    } else {
      window.close(); // 关闭当前tab页面
    }
  });
};
